import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { AttributeBlank, AttributesList, RestrictedWidthContainer } from "../../styled";
import { AddAttributeButton } from "../AddAttributeButton";
import isValidLayerReference from "./isValidLayerReference";
import { LayerReference } from "./LayerReference";
import { useLayerReferencesContext } from "./LayerReferencesProvider";

export interface LayerReferencesProps {
  withAddButton?: boolean;
  className?: string;
}

export const LayerReferences: FC<LayerReferencesProps> = ({ withAddButton = true, className }) => {
  const { t } = useTranslation("common");
  const { layerReferences, createLayerReference } = useLayerReferencesContext();
  const allValid = layerReferences.every(isValidLayerReference);

  return (
    <RestrictedWidthContainer className={className}>
      <AttributesList>
        {layerReferences.map(layerReference => (
          <AttributeBlank key={layerReference.id}>
            <LayerReference {...layerReference} />
          </AttributeBlank>
        ))}
      </AttributesList>
      {withAddButton && (
        <AddAttributeButton disabled={!allValid} onClick={createLayerReference}>
          {t("layer")}
        </AddAttributeButton>
      )}
    </RestrictedWidthContainer>
  );
};
